// src/utils/socket.js
import { io } from "socket.io-client";

const SOCKET_URL = "https://interviewnotebook.com"; // Change to backend URL in production

let socket = null;

/**
 * Connect to the WebSocket server with userId and optional JWT token
 */
export const connectSocket = (userId, token = null) => {
  if (socket) {
    if (socket.connected) {
      console.log("ℹ️ Socket already connected:", socket.id);
      return socket;
    } else {
      console.log("♻️ Reusing existing socket instance");
    }
  }

  socket = io(SOCKET_URL, {
    transports: ["websocket"],
    reconnection: true,
    reconnectionAttempts: Infinity, // keep trying
    reconnectionDelay: 2000,
    auth: {
      ...(token ? { token } : {}),
    },
  });

  // Clear previous listeners to avoid duplicates
  socket.off();

  socket.on("connect", () => {
    if (!socket.id) {
      console.warn("⚠️ socket.id not ready yet");
    }
    console.log("🔌 Connected to WebSocket server:", socket.id);

    // ✅ Register userId (to join private room)
    if (userId) {
      socket.emit("register", userId);
      console.log("✅ Registered userId:", userId);
    }
  });

  socket.on("disconnect", (reason) => {
    console.warn(`❌ Disconnected from WebSocket: ${reason}`);
  });

  socket.on("connect_error", (err) => {
    console.error("⚠️ WebSocket connection error:", err.message);
  });

  return socket;
};

/**
 * Get the current socket instance
 */
export const getSocket = () => socket;

export default socket;
